"use strict";
exports.__esModule = true;
exports.PlatformProducerOrderBuilder = exports.PlatformProducerOrderState = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var PricingCatalog_1 = require("../base/PricingCatalog");
var AccessoryInventory_1 = require("../producer/AccessoryInventory");
var PieceInventory_1 = require("../producer/PieceInventory");
var PlatformProducerOrderState;
(function (PlatformProducerOrderState) {
    PlatformProducerOrderState["NEW"] = "NEW";
    PlatformProducerOrderState["IN_PRODUCTION"] = "IN_PRODUCTION";
    PlatformProducerOrderState["SHIPPED"] = "SHIPPED";
    PlatformProducerOrderState["CANCELED"] = "CANCELED";
    PlatformProducerOrderState["REJECTED"] = "REJECTED";
    PlatformProducerOrderState["COMPLETED"] = "COMPLETED";
})(PlatformProducerOrderState = exports.PlatformProducerOrderState || (exports.PlatformProducerOrderState = {}));
var PlatformProducerOrderBuilder = /** @class */ (function () {
    function PlatformProducerOrderBuilder(platformProducerOrder) {
        this.platformProducerOrder = platformProducerOrder;
    }
    PlatformProducerOrderBuilder.initialiseWithPlatformProducerOrder = function (platformProducerOrder) {
        return new PlatformProducerOrderBuilder(platformProducerOrder);
    };
    PlatformProducerOrderBuilder.initialiseWithPlatformMerchantOrder = function (deliveryUnitSaleCatalog, platformMerchantOrder) {
        if (platformMerchantOrder.items.length === 0)
            throw new core_common_domain_1.Exception("Cannot initiate platform producer order because platform merchant order " + platformMerchantOrder.id + " has zero order items");
        var now = core_common_logic_1.CommonLogic.nowToDateTime();
        var currency = platformMerchantOrder.items[0].accessoryOrderItem.platformPrice.currency;
        var pricingCatalog = deliveryUnitSaleCatalog.pricingCatalogs.find(function (catalog) { return catalog.currency === currency; });
        if (pricingCatalog === undefined)
            throw new core_common_domain_1.Exception("Delivery Unit sale catalog " + deliveryUnitSaleCatalog.id + " does not contain a price catalog for currency " + currency);
        return new PlatformProducerOrderBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            state: PlatformProducerOrderState.NEW,
            producerPartyId: deliveryUnitSaleCatalog.partyId,
            producerDeliveryUnitId: deliveryUnitSaleCatalog.deliveryUnitId,
            deliveryUnitSaleCatalogId: deliveryUnitSaleCatalog.id,
            platformMerchantOrderId: platformMerchantOrder.id,
            delivery: platformMerchantOrder.merchantDelivery,
            items: platformMerchantOrder.items.map(function (platformMerchantOrderItem) {
                var piecePlatformPrice = PricingCatalog_1.PricePiece.findPricePiece(pricingCatalog.pieces, platformMerchantOrderItem.pieceOrderItem.pieceReference);
                if (piecePlatformPrice === undefined)
                    throw new core_common_domain_1.Exception("Delivery Unit sale catalog " + deliveryUnitSaleCatalog.id + "  does not contain a piece price for piece reference " + JSON.stringify(platformMerchantOrderItem.pieceOrderItem.pieceReference) + " and currency " + currency);
                var accessoryPlatformPrice = PricingCatalog_1.PriceAccessory.findPriceAccessory(pricingCatalog.accessories, platformMerchantOrderItem.accessoryOrderItem.accessoryReference);
                if (accessoryPlatformPrice === undefined)
                    throw new core_common_domain_1.Exception("Delivery Unit sale catalog " + deliveryUnitSaleCatalog.id + " does not contain a accessory price for accessory reference " + JSON.stringify(platformMerchantOrderItem.accessoryOrderItem.accessoryReference) + " and currency " + currency);
                var accessoryInventory = AccessoryInventory_1.AccessoryInventory.getOneAccessoryInventorysByAccessoryModelConfiguration(deliveryUnitSaleCatalog.inventoryCatalog.accessoryInventorys, platformMerchantOrderItem.accessoryOrderItem.accessoryReference);
                if (accessoryInventory === undefined)
                    throw new core_common_domain_1.Exception("Cannot locate an accessory inventory for accessory reference " + JSON.stringify(platformMerchantOrderItem.accessoryOrderItem.accessoryReference) + " in delivery unit sale catalog " + deliveryUnitSaleCatalog.id);
                var pieceInventory = PieceInventory_1.PieceInventory.getOnePieceInventorysByPieceModelConfiguration(deliveryUnitSaleCatalog.inventoryCatalog.pieceInventorys, platformMerchantOrderItem.pieceOrderItem.pieceReference);
                if (pieceInventory === undefined)
                    throw new core_common_domain_1.Exception("Cannot locate an piece inventory for piece reference " + JSON.stringify(platformMerchantOrderItem.pieceOrderItem.pieceReference) + " in delivery unit sale catalog " + deliveryUnitSaleCatalog.id);
                var platformProducerOrderItem = {
                    id: core_common_logic_1.CommonLogic.generateUUIDv4(),
                    platformMerchantOrderItemId: platformMerchantOrderItem.id,
                    accessories: [{
                            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
                            accessoryReference: platformMerchantOrderItem.accessoryOrderItem.accessoryReference,
                            inventoryReference: accessoryInventory.inventoryReference,
                            quantity: platformMerchantOrderItem.accessoryOrderItem.quantity
                        }],
                    pieces: [{
                            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
                            pieceReference: platformMerchantOrderItem.pieceOrderItem.pieceReference,
                            inventoryReference: pieceInventory.inventoryReference,
                            quantity: platformMerchantOrderItem.pieceOrderItem.quantity
                        }],
                    price: core_common_domain_1.Money.add(piecePlatformPrice.price, accessoryPlatformPrice.price)
                };
                return platformProducerOrderItem;
            }),
            history: [{
                    createdAt: now,
                    note: "",
                    state: PlatformProducerOrderState.NEW
                }],
            createdAt: now,
            updatedAt: now
        });
    };
    PlatformProducerOrderBuilder.prototype.getId = function () {
        return this.platformProducerOrder.id;
    };
    PlatformProducerOrderBuilder.prototype.withId = function (id) {
        this.platformProducerOrder.id = id;
        return this;
    };
    PlatformProducerOrderBuilder.prototype.getState = function () {
        return this.platformProducerOrder.state;
    };
    PlatformProducerOrderBuilder.prototype.withState = function (state, note) {
        if (note === void 0) { note = ""; }
        this.platformProducerOrder.state = state;
        this.platformProducerOrder.history.push({
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            note: note,
            state: state
        });
        return this;
    };
    PlatformProducerOrderBuilder.prototype.build = function () {
        return this.platformProducerOrder;
    };
    PlatformProducerOrderBuilder.prototype.buildUpdate = function () {
        return {
            state: this.platformProducerOrder.state,
            producerPartyId: this.platformProducerOrder.producerPartyId,
            producerDeliveryUnitId: this.platformProducerOrder.producerDeliveryUnitId,
            deliveryUnitSaleCatalogId: this.platformProducerOrder.deliveryUnitSaleCatalogId,
            platformMerchantOrderId: this.platformProducerOrder.platformMerchantOrderId,
            delivery: this.platformProducerOrder.delivery,
            items: this.platformProducerOrder.items,
            history: this.platformProducerOrder.history
        };
    };
    return PlatformProducerOrderBuilder;
}());
exports.PlatformProducerOrderBuilder = PlatformProducerOrderBuilder;
